/**
 * Android Back handling for the player shell.
 *
 * Direct / kiosk (Home launcher): never finish the activity — close PIN, then the Wi-Fi sheet, then the status panel.
 * Play Store builds: same dismiss steps, then exit (normal Back-exits behaviour).
 */
export type TAndroidBackAction = 'cancel_pin' | 'close_wifi' | 'close_status' | 'exit_app' | 'noop'

export function resolveAndroidBackAction(input: {
  /** Play Store distribution (`VITE_ANDROID_DISTRIBUTION=play` / native play). */
  isPlayDistribution: boolean
  pinOpen: boolean
  /** Site Wi-Fi sheet is up over the status panel. */
  wifiSheetOpen?: boolean
  statusOpen: boolean
}): TAndroidBackAction {
  if (input.pinOpen) {
    return 'cancel_pin'
  }
  if (input.wifiSheetOpen) {
    return 'close_wifi'
  }
  if (input.statusOpen) {
    return 'close_status'
  }
  return input.isPlayDistribution ? 'exit_app' : 'noop'
}
